import React,{useEffect} from 'react';
import { Heading, Box, Flex, Image, Text ,useMediaQuery, useColorMode,Avatar, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import { useState } from 'react';
import { Icon } from '@chakra-ui/react';
import { motion,} from 'framer-motion';
import me from "../../assets/me.jpg";
import js from "../../assets/js.png";
import cpp from "../../assets/cpp.png";
import react from "../../assets/react.png";
import css from "../../assets/css.png";
import html from "../../assets/html.png";
import node from "../../assets/node.png";
import ex from "../../assets/ex.png";
import mongo from "../../assets/mongo.png";
import oop from "../../assets/oop.png";
import dsa from "../../assets/dsa.png";
import ml from "../../assets/ml.png"
import os from "../../assets/os.png"
import python from "../../assets/python.jpeg";
import vscode from "../../assets/vscode.jpeg";
import "../../App.css";
import { questions } from './constants';



const Questions = () => {
  

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleAccordionClick = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;

  return (
    <Flex
      justifyContent="center"
      width="100%"
      direction="column"
      alignItems="center"
    >
      <Heading fontSize="36px" fontWeight="bold" fontFamily="Times New Roman">
      <Text
              // as="span"
              bgGradient={gradientColor}
              bgClip="text"
              fontFamily={"Times New Roman"}
            >
              About Me
            </Text>
      </Heading>
      <Accordion
        margin="2rem"
        allowToggle
        width="100%" // Increase the width
        maxW="800px" // Limit the maximum width of the Accordion
      >
        {questions.map((q, index) => (
          <AccordionItem key={index}>
            <h2>
              <AccordionButton onClick={() => handleAccordionClick(index)}>
                <Box flex="1" textAlign="center">
                  {q.question}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel>
              {q.answer.map((point, pointIndex) => (
                <Flex align="center" key={pointIndex}>
                  <Icon as={point.icon} boxSize={4} color={point.color} mr={2} />
                  <Text>{point.point}</Text>
                </Flex>
              ))}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Flex>
  );
};

const MeComponent = () => {
  const [isSmallerScreen] = useMediaQuery('(max-width: 768px)');

  useEffect(()=>{
    window.scrollTo(0,0);
  })

  return (
    <Flex direction={isSmallerScreen ? 'column' : 'row'} alignItems={"center"} justifyContent={"center"}>
      <Flex
        width={isSmallerScreen ? '100%' : '30%'}
        alignContent={['center']}
        justifyContent={'center'}
        p={4}
        transition="transform 0.3s" 
        _hover={{ transform: 'scale(1.1)' }}
        mr={isSmallerScreen ? '0' : '2rem'}
      >
        <Image borderRadius="100%" src={me} p="4" />
      </Flex>
      <Flex
        width={isSmallerScreen ? '100%' : '50%'}
        alignContent={'center'}
        justifyContent={'center'}
        height={"50%"}
        boxShadow = '0 10px 10px rgba(0, 0, 0, 0.5)'
        p={4}
      >
        <Questions />
      </Flex>
    </Flex>
  );
};


const Skills = ({src}) => {
  const [isSmallerScreen] = useMediaQuery("(max-width: 700px)");
  return (

    <motion.div
        animate={{
          translateY: "20px",
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      >
        <Avatar
          src={src}
          alt= "Programming Language"
          borderRadius={"1.5rem"}
          size={isSmallerScreen ? "md" : "xl"}
          m="4"
          boxShadow = '0 10px 10px rgba(0, 0, 0, 0.5)'
          objectFit = 'contain'
        />
      </motion.div>  
  );
}


const SkillComponent = () => {
  const [isSmallerScreen] = useMediaQuery("(max-width: 700px)");
  const { colorMode } = useColorMode();
  const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;
  return (
    <Flex  
    mt={"50px"} 
    mb={"50px"}
    borderRadius="10px"
    mx={isSmallerScreen?"10px":"100px"} 
    direction="column" alignItems="center" 
    bgColor={colorMode === "light" ? "white" : "dark"}>
      <Heading fontSize="60px" textAlign="center" mb="10" fontFamily={'Times New Roman'} letterSpacing={"10"}>
       <Text
              // as="span"
              bgGradient={gradientColor}
              bgClip="text"
              fontFamily={"Times New Roman"}
            >
              SKILLS
            </Text>
      </Heading>
      <Flex justifyContent="center" flexWrap="wrap">
        <Skills src={cpp} />
        <Skills src={js}/>
        <Skills src={react} />
        <Skills src={python} />
        <Skills src={node} />
        <Skills src={ex} />
        <Skills src={mongo} />
        <Skills src={html} />
        <Skills src={css} />
        <Skills src={ml} />
        <Skills src={dsa} />
        <Skills src={oop} />
        <Skills src={os} />
        <Skills src={vscode} />
      </Flex>
    </Flex>
  );
}

const About = () => {
  return (
    <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -50 }}
    transition={{ duration: 0.5 }}
  >
    <div>
      <MeComponent />
      <SkillComponent />
      
    </div>
  </motion.div>
  );
}

export default About;


